import React from 'react';
export function Emphasize(_a) {
    var target = _a.target;
    if (target.indexOf('<em>') === -1) {
        return React.createElement(React.Fragment, null, target);
    }
    return (React.createElement(React.Fragment, null, target.split('<em>').reduce(function (acc, str, i) {
        var _a = str.split('</em>'), before = _a[0], after = _a[1];
        if (after) {
            acc.push(React.createElement("em", { key: "".concat(i, "-").concat(before) }, before));
            acc.push(after);
        }
        else if (before) {
            acc.push(before);
        }
        return acc;
    }, [])));
}
//# sourceMappingURL=Emphasize.js.map